import { combineReducers } from 'redux';
import { userAbilitiesReducer } from './reducers/user-abilities-reducer';
import userstore from './reducers/user-store';

export default combineReducers({
  userAbilitiesReducer,
  userstore,
});
